import { app } from "../serviceLMS";
import { updateContentProgress } from "../UserCourseService";
import { STREAM_VIDEO, GET_LAST_POSITION } from "../URLs";

export const fetchVideoBlob = async (fileName, onProgress) => {
  try {
    const res = await app.get(STREAM_VIDEO(fileName), {
      responseType: "blob",
      timeout: 60000,
      onDownloadProgress: (e) => {
        if (e.total && onProgress) {
          onProgress(Math.round((e.loaded / e.total) * 100));
        }
      },
    });
    const blob = new Blob([res.data], { type: "video/mp4" });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("API Error fetching video blob:", error);
    throw new Error(error?.response?.data?.message || "Failed to load video");
  }
};

export const fetchLastWatchedPosition = async (userId, courseId, contentId) => {
  try {
    const res = await app.get(GET_LAST_POSITION(userId, courseId, contentId));
    return Number(res.data) || 0;
  } catch (error) {
    console.error("API Error fetching last position:", error);
    return 0;
  }
};

export const saveVideoProgress = async (userId, contentId, courseId, position, completionPercentage, currentPortal, isAcknowledged) => {
  try {
     if (isAcknowledged) return;
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    const isAdmin =currentPortal === "admin" && roles.some(r => ["ADMIN", "ADMIN_SUPPORT"].includes(r));
    if (isAdmin) return;
    await updateContentProgress(userId, contentId, courseId, position, completionPercentage, "video");
  } catch (error) {
    console.error("API Error saving video progress:", error);
    throw error;
  }
};

export const fetchVideoUrl = (fileName) => {
  return STREAM_VIDEO(fileName);
};